import { apiClient } from "../../../../../api/client";

export const nfsService = {
  getFechamentoStatus: async () => {
    return apiClient.post<any>("/gestorEntregoFechamento", {});
  },

  enviarEmailFechamento: async (params: { enviar_email: boolean; enviar_para_contato: boolean }) => {
    return apiClient.post<any>("/gestorEntregoFechamento", params);
  },

  calcularSaldoRemanescente: async () => {
    return apiClient.post<any>("/gestorSaldoRemanescente", { ops: "entrego" });
  },

  processarNfsSaldo: async (params: { data_inicio_periodo: string; ops: string }) => {
    return apiClient.post<any>("/gestorNFSHandler", {
      tipo_nfs: "saldo_remanescente",
      ...params,
    });
  },

  enviarEmailSaldo: async (params: { data_inicio_periodo: string }) => {
    return apiClient.post<any>("/gestorNFSSaldoRemanescenteEmail", params);
  },

  getResumoNfs: async (params: { data_periodo_inicio: string }) => {
    return apiClient.post<any>("/gestorNFSSaldoRemanescenteResumo", params);
  },

  dispararDownloadNfs: async (params: { segunda: string }) => {
    return apiClient.post<any>("/gestorNFSZipSemana", { acao: "disparar_download", ...params });
  },

  gerarZipsNfs: async (params: { segunda: string }) => {
    return apiClient.post<any>("/gestorNFSZipSemana", { acao: "gerar_zips", ...params });
  },

  buscarLinksZips: async (params: { segunda: string }) => {
    return apiClient.post<any>("/gestorNFSZipSemana", { acao: "links", ...params });
  },

  verificarCompletude: async (params: { segunda: string }) => {
    return apiClient.post<any>("/gestorNFSZipSemana", { acao: "completude", ...params });
  },
};
